import React, { useState } from 'react';
import statefulIcons from './statefulIconMapping.json.js';
import Icon from '../Icon/Icon.js';

const getVariant = (disabled, hover, selected, localVariant) => {
  let finalVariant = 'default';
  if (disabled) {
    finalVariant = 'disabled';
  } else if (selected) {
    finalVariant = 'selected';
  } else if (hover) {
    finalVariant = 'hover';
  } else if (!selected && localVariant === 'hover') {
    finalVariant = 'hover';
  } else if (typeof hover === 'undefined' && localVariant === 'hover') {
    finalVariant = 'hover';
  }
  return finalVariant;
};
const getIcon = (code, disabled, hover, selected, localVariant) => {
  const variant = getVariant(disabled, hover, selected, localVariant);
  let icon = `${code}-default`;
  if (code && typeof statefulIcons[code][variant] !== 'undefined') {
    icon = `${code}-${variant}`;
  }
  return icon;
};
const StatefulIcon = _ref => {
  let {
    code,
    disabled = false,
    selected,
    hover
  } = _ref;
  // Holds the active variant that should be displayed.
  const [variant, setVariant] = useState('default');
  const icon = getIcon(code, disabled, hover, selected, variant);
  return icon ? /*#__PURE__*/React.createElement(Icon, {
    onFocus: () => setVariant('selected'),
    onMouseOver: () => setVariant('hover'),
    onMouseOut: () => setVariant('default'),
    onBlur: () => setVariant('default'),
    icon: icon
  }) : null;
};
var StatefulIcon$1 = StatefulIcon;

export { StatefulIcon$1 as default };
//# sourceMappingURL=StatefulIcon.js.map
